import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Fade"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M6.18019 18.855L5.25019 20.0025C6.17913 20.7925 7.24047 21.4121 8.38519 21.8325L8.90269 20.43C7.90977 20.0689 6.9882 19.5357 6.18019 18.855ZM3.14258 13.5L1.64258 13.8075C1.85648 15.0192 2.28035 16.1842 2.89508 17.25L4.19258 16.5C3.67357 15.5674 3.31841 14.5527 3.14258 13.5ZM8.86519 3.57L8.34769 2.1675C7.2162 2.59185 6.16785 3.21122 5.25019 3.9975L6.18019 5.145C6.97691 4.46803 7.8855 3.93506 8.86519 3.57ZM4.19251 7.5L2.89501 6.75C2.29197 7.81909 1.87599 8.98333 1.66501 10.1925L3.16501 10.4475C3.33396 9.41284 3.68165 8.41547 4.19251 7.5ZM12.0002 1.5V3C16.9707 3 21.0002 7.02944 21.0002 12C21.0002 16.9706 16.9707 21 12.0002 21V22.5C17.7992 22.5 22.5002 17.799 22.5002 12C22.5002 6.20101 17.7992 1.5 12.0002 1.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Fade.vue"]]);
